import { collection, addDoc, doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

const SESSION_ID_KEY = 'reg_session_id';
const SESSION_PARAMS_KEY = 'reg_source_params';
const EVENT_DOC_ID_KEY = 'reg_event_id';

const SOCIAL_CHANNELS = ['instagram', 'tiktok', 'facebook', 'twitter'];
const WEB_CHANNELS = ['google', 'google_ads', 'bing', 'youtube', 'wp', 'wordpress', 'website', 'web'];

export function parseRefParams(searchString) {
  const p = new URLSearchParams(searchString);
  return {
    ref: p.get('ref') || '',
    utmSource: p.get('utm_source') || '',
    utmMedium: p.get('utm_medium') || '',
    utmCampaign: p.get('utm_campaign') || '',
    utmContent: p.get('utm_content') || '',
    utmTerm: p.get('utm_term') || '',
  };
}

export function getOrCreateSessionId() {
  try {
    let id = localStorage.getItem(SESSION_ID_KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(SESSION_ID_KEY, id);
    }
    return id;
  } catch {
    return crypto.randomUUID();
  }
}

export function saveParamsToSession(params) {
  try {
    sessionStorage.setItem(SESSION_PARAMS_KEY, JSON.stringify(params));
  } catch {}
}

export function loadParamsFromSession() {
  try {
    const raw = sessionStorage.getItem(SESSION_PARAMS_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function saveEventDocId(id) {
  try {
    sessionStorage.setItem(EVENT_DOC_ID_KEY, id);
  } catch {}
}

export function loadEventDocId() {
  try {
    return sessionStorage.getItem(EVENT_DOC_ID_KEY) || null;
  } catch {
    return null;
  }
}

export function mapRefToSalesChannel(ref = '', utmSource = '') {
  const val = (ref || utmSource || '').toLowerCase().trim();
  if (!val) return 'web';
  if (SOCIAL_CHANNELS.some((c) => val.includes(c))) return 'instagram';
  if (WEB_CHANNELS.some((c) => val === c)) return 'web';
  if (val === 'referral') return 'referral';
  return 'other';
}

export async function trackVisit(params) {
  try {
    const sessionId = getOrCreateSessionId();
    const docRef = await addDoc(collection(db, 'registration_events'), {
      sessionId,
      ref: params.ref || '',
      utmSource: params.utmSource || '',
      utmMedium: params.utmMedium || '',
      utmCampaign: params.utmCampaign || '',
      utmContent: params.utmContent || '',
      utmTerm: params.utmTerm || '',
      landingUrl: window.location.href,
      status: 'visited',
      visitedAt: serverTimestamp(),
      startedAt: null,
      completedAt: null,
      businessId: null,
      userAgent: navigator.userAgent,
    });
    saveEventDocId(docRef.id);
    return docRef.id;
  } catch {
    return null;
  }
}

export async function trackFormStart() {
  try {
    const eventDocId = loadEventDocId();
    if (!eventDocId) return;
    await updateDoc(doc(db, 'registration_events', eventDocId), {
      status: 'started',
      startedAt: serverTimestamp(),
    });
  } catch {}
}

export async function trackCompletion(businessId) {
  try {
    const eventDocId = loadEventDocId();
    if (!eventDocId) return;
    await updateDoc(doc(db, 'registration_events', eventDocId), {
      status: 'completed',
      completedAt: serverTimestamp(),
      businessId: businessId || null,
    });
  } catch {}
}

export function toSlug(str) {
  return (str || '')
    .toLowerCase()
    .replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ş/g, 's')
    .replace(/ı/g, 'i').replace(/ö/g, 'o').replace(/ç/g, 'c')
    .replace(/[^a-z0-9]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
}

export function buildCampaignLink(campaign) {
  const base = window.location.origin;
  const params = new URLSearchParams();
  if (campaign.ref) params.set('ref', campaign.ref);
  if (campaign.utmSource) params.set('utm_source', campaign.utmSource);
  if (campaign.utmMedium) params.set('utm_medium', campaign.utmMedium);
  if (campaign.utmCampaign) params.set('utm_campaign', campaign.utmCampaign);
  if (campaign.utmContent) params.set('utm_content', campaign.utmContent);
  if (campaign.utmTerm) params.set('utm_term', campaign.utmTerm);
  const qs = params.toString();
  return `${base}/register${qs ? `?${qs}` : ''}`;
}
